import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import StockMain from "./StockMain";

const Stock: React.FC = () => {
  return (
    <div className="orders">
      <Sidebar activeTab="Stock" />
      <StockMain />
    </div>
  );
};

export default Stock;
